<template>
  <div class="companyIntro">
    <div class="indexBody">
      <div>
        <div class="leftBox">
          <div>
            <div class="logoBox">
              <img :src="detail.logo==''?require('@/assets/cloud_shop.png'):detail.logo">
            </div>
            <div></div>
            <div>{{ detail.title }}</div>
            <div>
              <div><span>{{detail.ying}}</span>年</div>
              <!-- <div>"{{ detail.ying }}"</div> -->
              <img :class="item.index==1?'':'wanshang'"  v-for="(item,i) in detail.brand" :key="i" :src="item.url">
            </div>
            <div>
              <div>认证信息：</div>
              <img src="@/assets/rzxx.png">
            </div>
            <div>
              <div>经营执照：</div>
              <img src="@/assets/yyzz_icon.png">
            </div>
            <div>
              <div>社会统一代码：</div>
              <div>{{ detail.enterprise.code }}</div>
            </div>
            <div class="btnBox">
              <a-button type="primary" @click="toShop">进入店铺</a-button>
              <a-button type="primary" ghost @click="allGoods">全部商品</a-button>
            </div>
            <!-- <a-divider />
            <div class="scoreBox">
              <img src="@/assets/score.png">
              <div>
                <div>
                  <div>{{detail.pf_spff}}</div>
                  <div>商品<br>丰富</div>
                </div>
                <div>
                  <div>{{detail.pf_ksxy}}</div>
                  <div>快速<br>响应</div>
                </div>
                <div>
                  <div>{{detail.pf_gylzc}}</div>
                  <div>供应链<br>支持</div>
                </div>
                <div>
                  <div>{{detail.pf_ghwd}}</div>
                  <div>供货<br>稳定</div>
                </div>
              </div>
              <div>参与评分<span class="iconfont icon-right"></span></div>
            </div> -->
          </div>
          <div>
            <div>联系方式</div>
            <div v-if="detail.person">
              <div>联系人</div>
              <div>{{detail.person}}</div>
            </div>
            <div v-if="detail.post">
              <div>职务</div>
              <div>{{detail.post}}</div>
            </div>
            <div v-if="detail.phone">
              <div>公司电话</div>
              <div>{{detail.phone}}</div>
            </div>
            <div v-if="detail.email">
              <div>邮箱</div>
              <div>{{detail.email}}</div>
            </div>
            <div v-if="detail.fax">
              <div>传真</div>
              <div>{{detail.fax}}</div>
            </div>
            <div v-if="detail.address">
              <div>公司地址</div>
              <div>{{detail.city_str+detail.address}}</div>
            </div>
          </div>
        </div>
        <div class="rightBox">
          <div class="title">公司介绍</div>
          <div v-if="detail.content" class="content richText" v-html="detail.content">
          </div>
          <div v-else class="content">
            暂无介绍
          </div>
          <template v-if="detail.credential.length>0">
            <div class="title">企业资质</div>
            <div class="enterpriseBox">
              <div v-for="(item,i) in detail.credential" :key="i">
                <div class="image-container" :style="{backgroundImage:item.photo_url?`url(${encodedUrl(item.photo_url)})`:'none'}"></div>
                <div>{{item.title}}</div>
              </div>
            </div>
          </template>
          <!-- <div class="image-container">
            <img v-if="detail.enterprise.authorize_letter" :src="baseUrl+detail.enterprise.authorize_letter">
          </div>
          <div class="image-container">
            <img v-if="detail.enterprise.business_license" :src="baseUrl+detail.enterprise.business_license">
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "companyIntro",
  props: {
    detail: Object,
    list: Array,
  },
  computed: {
    baseUrl() {
      return this.$store.state.baseUrl;
    },
  },
  data: function () {
    return {};
  },
  methods: {
    encodedUrl(url) {
      return url.replace(/\(/g, '%28').replace(/\)/g, '%29');
    },
    toShop() {
      this.$emit("toShop");
    },
    allGoods() {
      this.$emit("allGoods");
    },
  },
};
</script>
<style lang="less">
@media screen and (min-width: 1025px) {
  .companyIntro {
    width: 100%;
    min-width: 1200px;
    overflow: hidden;
    .carousel {
      font-size: 0;
      width: 100%;
      min-width: 1200px;
      height: auto;
      img {
        width: 100%;
        height: 100%;
        min-width: 1200px;
        height: auto;
      }
    }
    .indexBody {
      width: 100%;
      min-width: 1200px;
      overflow: hidden;
      background-color: #f1f1f1;
      > div {
        width: 1200px;
        padding: 40px 0;
        display: inline-flex;
        justify-content: space-between;
        > .leftBox {
          > div:first-child {
            width: 260px;
            // height: 540px;
            background-color: #fff;
            border-radius: 4px;
            text-align: center;
            padding: 20px;
            .logoBox {
              background-image: linear-gradient(
                18deg,
                #d03d3c 11%,
                #f3c2c2 87%
              );
              padding: 2px;
              width: 64px;
              height: 64px;
              border-radius: 50%;
              margin-right: 20px;
              display:inline-block;
              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }
            > div:nth-child(2) {
              font-size: 12px;
            }
            > div:nth-child(3) {
              font-size: 16px;
              font-weight: 600;
              margin: 24px 0;
              width:196px;
              text-align:center;
              white-space: pre-wrap;
              word-break: break-all;
              display:inline-block;
            }
            > div:nth-child(4) {
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              margin-bottom: 15px;
              flex-wrap: wrap;
              > div {
                font-size: 14px;
                color: #333;
                margin-right: 20px;
                white-space: nowrap;
                span {
                  font-size: 24px;
                  font-weight: 600;
                  color: var(--default);
                }
              }
              img {
                width: auto;
                height: 35px;
                margin-right:5px;
              }
              .wanshang {
                height:20px;
              }
            }
            > div:nth-child(5),
            > div:nth-child(6),
            > div:nth-child(7) {
              display: flex;
              height: 17px;
              line-height: 17px;
              margin-bottom: 15px;
              white-space: nowrap;
              > div:first-child {
                font-size: 12px;
                color: #999;
              }
              img {
                width: 20px;
                height: 20px;
              }
            }
            .btnBox {
              padding-top: 9px;
              display: flex;
              justify-content: space-between;
              button {
                width: 100px;
                height: 32px;
                border-radius: 16px;
              }
            }
            .ant-divider {
              margin: 14px 0;
            }
            .scoreBox {
              height: 120px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              img {
                width: 134px;
                height: 20px;
              }
              > div:nth-child(2) {
                display: flex;
                justify-content: space-between;
                > div {
                  > div:first-child {
                    font-size: 18px;
                  }
                  > div:last-child {
                    font-size: 12px;
                    color: #999;
                  }
                }
              }
              > div:last-child {
                height: 20px;
                line-height: 20px;
                color: var(--default);
              }
            }
          }
          > div:nth-child(2) {
            width: 260px;
            background-color: #fff;
            border-radius: 4px;
            text-align: center;
            padding: 20px;
            margin-top: 20px;
            > div:first-child {
              font-size: 18px;
              font-weight: 600;
              text-align: left;
              margin-bottom: 20px;
            }
            .ant-collapse-item {
              text-align: left;
              background-color: #fff;
              border-bottom: 1px dashed #ccc;
            }
            .ant-collapse {
              border: none;
              > .ant-collapse-item:last-child {
                border-bottom: none;
              }
            }
            .ant-collapse-item-active {
              border-bottom: none;
            }
            .ant-collapse-content-active,
            .ant-collapse-content {
              border-top: none;
            }
            .ant-collapse-content-box {
              p {
                margin-bottom: 10px;
                padding-left: 10px;
              }
              p:hover {
                cursor: pointer;
                color: var(--default);
              }
            }
          }
          > div:last-child {
            width: 260px;
            background-color: #fff;
            border-radius: 4px;
            text-align: center;
            padding: 20px;
            margin-top: 20px;
            > div:first-child {
              font-size: 18px;
              font-weight: 600;
              text-align: left;
              margin-bottom: 20px;
            }
            > div:not(:first-child) {
              display: flex;
              align-items: flex-start;
              font-size: 12px;
              text-align: left;
              margin-bottom: 12px;
              > div:first-child {
                width: 72px;
                color: #999999;
              }
              > div:last-child {
                width: calc(100% - 72px);
                white-space: pre-wrap;
                word-break: break-all;
                word-wrap: break-word;
              }
            }
          }
        }
        > .rightBox {
          width: 920px;
          background: #fff;
          padding: 20px;
          .title {
            text-align: left;
            font-size: 24px;
            font-weight: 600;
            color: #000;
            padding-bottom: 13px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #e1e1e1;
          }
          .title::before {
            content: "";
            display: inline-block;
            width: 4px;
            height: 26px;
            background-color: var(--default);
            margin-right: 10px;
          }
          .content {
            padding: 40px 0;
            font-size: 14px;
            line-height: 28px;
            letter-spacing: 0px;
            text-align: left;
            // text-indent:28px;
          }
          .image-container {
            width: 100%;
            height: auto;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .enterpriseBox{
            padding:30px 0;
            display:flex;
            flex-wrap: wrap;
            justify-content: space-between;
            >div{
              width:calc(840px / 3);
              display:flex;
              flex-direction: column;
              justify-content: space-between;
              .image-container{
                width:100%;
                height:calc(840px / 9 * 4);
                border-radius: 6px;
                border:2px solid #ccc;
                box-sizing: border-box;
                background-size: auto 100%;
                background-position: center;
                background-repeat: no-repeat;
              }
              img{
                width:100%;
                height:auto;
              }
              >div{
                margin-top:12px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
            > div:last-child:nth-child(3n - 1) {
              margin-right: calc((100% + 20px) / 3)
            }
          }
        }
      }
    }
    .ant-carousel .slick-slide {
      text-align: center;
      background: #364d79;
      overflow: hidden;
    }

    .ant-carousel .custom-slick-arrow {
      width: 30px;
      height: 56px;
      font-size: 25px;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.5);
      opacity: 1;
      display: inline-flex !important;
      justify-content: center !important;
      align-items: center !important;
    }
    .ant-carousel .custom-slick-arrow:before {
      display: none;
    }

    .ant-carousel .custom-slick-arrow:hover {
      opacity: 0.7;
    }

    .ant-carousel .slick-slide span {
      color: #fff;
    }

    .dots {
      bottom: 30px;
    }

    .dots li {
      background-color: rgba(51, 51, 51, 0.2);
      padding: 4px 3px;
      margin: 0;
    }
    .dots li button {
      width: 8px;
      height: 8px;
      margin: 0 2px;
      border-radius: 100px;
    }
    .dots .slick-active button {
      width: 32px !important;
    }

    .dots li:first-child {
      padding-left: 4px;
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
    }

    .dots li:last-child {
      padding-right: 4px;
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
    }
  }
}
@media screen and (max-width: 1024px) {
  .companyIntro {
    width: 100%;
    overflow: hidden;
    .indexBody {
      width: 100%;
      overflow: hidden;
      background-color: #f1f1f1;
      > div {
        width: 100%;
        padding: 12px 0;
        display: inline-flex;
        justify-content: space-between;
        > .leftBox {display:none}
        > .rightBox {
          width: 100%;
          background: #fff;
          padding: 12px;
          .title {
            display:none;
          }
          .title::before {
            content: "";
            display: inline-block;
            width: 4px;
            height: 26px;
            background-color: var(--default);
            margin-right: 10px;
          }
          .content {
            font-size: 14px;
            line-height: 28px;
            letter-spacing: 0px;
            text-align: left;
            // text-indent:28px;
          }
          .image-container {
            width: 100%;
            height: auto;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .enterpriseBox{
            padding:30px 0;
            display:flex;
            flex-wrap: wrap;
            justify-content: space-between;
            >div{
              width:calc((100vw - 36px) / 2);
              display:flex;
              flex-direction: column;
              justify-content: space-between;
              .image-container{
                width:100%;
                height:calc((100vw - 36px) / 6 * 4);
                border-radius: 6px;
                border:2px solid #ccc;
                box-sizing: border-box;
                background-size: auto 100%;
                background-position: center;
                background-repeat: no-repeat;
              }
              img{
                width:100%;
                height:auto;
              }
              >div{
                margin-top:12px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
            > div:last-child:nth-child(3n - 1) {
              margin-right: calc((100% + 20px) / 3)
            }
          }
        }
      }
    }
    .ant-carousel .slick-slide {
      text-align: center;
      background: #364d79;
      overflow: hidden;
    }

    .ant-carousel .custom-slick-arrow {
      width: 30px;
      height: 56px;
      font-size: 25px;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.5);
      opacity: 1;
      display: inline-flex !important;
      justify-content: center !important;
      align-items: center !important;
    }
    .ant-carousel .custom-slick-arrow:before {
      display: none;
    }

    .ant-carousel .custom-slick-arrow:hover {
      opacity: 0.7;
    }

    .ant-carousel .slick-slide span {
      color: #fff;
    }

    .dots {
      bottom: 30px;
    }

    .dots li {
      background-color: rgba(51, 51, 51, 0.2);
      padding: 4px 3px;
      margin: 0;
    }
    .dots li button {
      width: 8px;
      height: 8px;
      margin: 0 2px;
      border-radius: 100px;
    }
    .dots .slick-active button {
      width: 32px !important;
    }

    .dots li:first-child {
      padding-left: 4px;
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
    }

    .dots li:last-child {
      padding-right: 4px;
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
    }
  }
}
</style>